import {
    showAnimalDetails,
    showCageDetails,
    showDrugPackageDetails,
    showDrugRequestDetails,
    showEmbryoDetails,
    showLicenseDetails,
    showOrderRequestDetails,
    showPupDetails,
    showServiceRequestDetails,
    showTankDetails,
    showWorkRequestDetails,
} from "../dialogs";

export class ProcedureShortcuts {
    /** Execute the shortcut functions.
     *
     * This method calls the function for the given data.
     *
     * Example:
     *
     *   // open the cage list details for cage 60
     *   procedureShortcuts.execute(['openCageDetails', 60]);
     *
     * @param data - The functions to start and its arguments.
     */
    public execute = (data: [keyof ProcedureShortcuts["shortcutFunctions"], ...any]): void => {
        if (Array.isArray(data) && data.length > 0) {
            const [name, ...args] = data;
            if (name in this.shortcutFunctions) {
                this.shortcutFunctions[name].apply(this, args);
            }
        }
    };

    /* The actual available shortcut functions. */
    private shortcutFunctions = {
        // function to open the pup list and the detail dialog of the given pup
        openPupDetails(pupId: number) {
            showPupDetails({
                pupId,
            });
        },

        // function to open the animal list and the detail dialog of the given animal
        openAnimalDetails(animalId: number) {
            showAnimalDetails({
                animalId,
            });
        },

        // function to open the cage list and the detail dialog of the given cage
        openCageDetails(cageId: number) {
            showCageDetails({
                cageId,
            });
        },

        // function to open the tank list and detail dialog of the given tank id
        openTankDetails(tankId: number) {
            showTankDetails({
                tankId,
            });
        },

        // function to open the embryo list and the detail dialog of the given embryo
        openEmbryoDetails(embryoGroupKey: string) {
            showEmbryoDetails({
                embryoGroupKey,
            });
        },

        // function to open the order request list and detail dialog for the given order request id
        openOrderRequestDetails(orderRequestId: number) {
            showOrderRequestDetails({
                orderRequestId,
            });
        },

        // function to open the work request list and detail dialog for the given work request id
        openWorkRequestDetails(workRequestId: number) {
            showWorkRequestDetails({
                workRequestId,
            });
        },

        // function to open the drug package list and the detail dialog of the given drug package
        openDrugPackageDetails(drugPackageId: number) {
            showDrugPackageDetails({
                drugPackageId,
            });
        },

        // function to open the service request list and detail dialog for the given service request id
        openServiceRequestDetails(serviceRequestId: number) {
            showServiceRequestDetails({
                serviceRequestId,
            });
        },

        openDrugRequestDetails(drugRequestId: number) {
            showDrugRequestDetails({
                drugRequestId,
            });
        },

        openLicenseDetails(licenseId: number) {
            showLicenseDetails({
                licenseId,
            });
        },
    };
}
